import { PromptScopeType, PromptType } from './constants';
import type { Prompt, PromptScope } from './types';

export const OBSOLETE_V1_PROMPTS: ReadonlySet<string> = new Set([
  `${PromptScopeType.Word}/${PromptType.Ask}`,
  `${PromptScopeType.Word}/${PromptType.Translate}`,
  `${PromptScopeType.Passage}/${PromptType.Ask}`,
  `${PromptScopeType.Document}/${PromptType.Ask}`,
  `${PromptScopeType.Passage}/${PromptType.Simplify}`,
  `${PromptScopeType.Passage}/${PromptType.PermanentNote}`,
  `${PromptScopeType.Passage}/${PromptType.Flashcard}`,
  `${PromptScopeType.Passage}/${PromptType.GenerateQuestions}`,
  `${PromptScopeType.Passage}/${PromptType.Translate}`,
  `${PromptScopeType.Document}/${PromptType.GenerateQuestions}`,
  `${PromptScopeType.Document}/${PromptType.WriteReview}`,
  `${PromptScopeType.Document}/${PromptType.PermanentNote}`,
]);

export function isObsoleteV1Prompt(scope: PromptScopeType, type: PromptType): boolean {
  return OBSOLETE_V1_PROMPTS.has(`${scope}/${type}`);
}

// A toggle-only override copies the default with isEnabled flipped, so compare content
// like useHasCustomV1TagPrompt does (RW-45946).
export function isCustomizedV1Prompt(prompt: Prompt, defaultScope: PromptScope | undefined): boolean {
  const defaultPrompt = defaultScope?.prompts.find((p) => p.type === prompt.type);
  if (!defaultPrompt) {
    return true;
  }
  return (
    prompt.template !== defaultPrompt.template ||
    prompt.system !== defaultPrompt.system ||
    prompt.title !== defaultPrompt.title ||
    prompt.model !== defaultPrompt.model
  );
}

// Obsolete types are hidden (superseded by skills) unless the user customized them.
export function isVisibleV1Prompt(
  scope: PromptScopeType,
  prompt: Prompt,
  defaultScope: PromptScope | undefined,
): boolean {
  return !isObsoleteV1Prompt(scope, prompt.type) || isCustomizedV1Prompt(prompt, defaultScope);
}
